"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Circle = void 0;
var react_1 = __importDefault(require("react"));
var recharts_1 = require("recharts");
exports.Circle = function (props) {
    var cx = props.cx, cy = props.cy, stroke = props.stroke;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(recharts_1.Dot, __assign({ cx: cx, cy: cy, r: 12 }, { fill: stroke, opacity: 0.3 }, { className: 'hover-shape' })),
        react_1.default.createElement(recharts_1.Dot, __assign({ cx: cx, cy: cy, r: 4 }, { fill: stroke }))));
};
//# sourceMappingURL=Circle.js.map